import { IntegrationAppInstallation_State, SlimIntegrationApp } from "@proto/odoo/integrations";
import { Subscription } from "../subscription/subscription.model";

export interface LabelData {
  id?: number;
  type: 'label';
  name: string;
  key: string;
  onUninstall: 'keep' | 'remove';
  labelType: 'generic' | 'skill';
  visible: 'visible' | 'invisible';
}

export type ProvisioningEntry = LabelData;

export type ProvisioningFormType = 'label';

export type ProvisioningDialogFormType = 'selectEntryType' | 'fillForm';

export function getProvisioningTypeLabelKey(
  value: ProvisioningEntry['type']
): string {
  return integrationAppSelectOptions.type.find(
    option => option.value === value
  )?.labelKey ?? value;
}

export function getOnUninstallLabelKey(
  value: ProvisioningEntry['onUninstall']
): string {
  return integrationAppSelectOptions.uninstall.find(
    option => option.value === value
  )?.labelKey ?? value;
}

export interface PermissionsWithSecret {
  identifier: string;
  scopes: string[];
  generatedSecret?: string;
}

export interface Permission {
  id: number;
  label: string;
}

// add values for new types in the future
export const integrationAppSelectOptions = {
  type: [
    {
      labelKey: 'integration-apps_type_options_label',
      value: 'label',
    },
  ],
  uninstall: [
    {
      labelKey: 'integration-apps_uninstall_options_keep',
      value: 'keep',
    },
    {
      labelKey: 'integration-apps_uninstall_options_remove',
      value: 'remove',
    },
  ],
  labelType: [
    {
      labelKey: 'integration-apps_label_type_options_generic',
      value: 'generic',
    },
    {
      labelKey: 'integration-apps_label_type_options_skill',
      value: 'skill',
    },
  ],
  labelVisibility: [
    {
      labelKey: 'integration-apps_label_visibility_options_visible',
      value: 'visible',
    },
    {
      labelKey: 'integration-apps_label_visibility_options_invisible',
      value: 'invisible',
    },
  ],
} as const;

export type SubWithVersion = { 
  sub: Subscription; 
  version?: number; 
  state?: IntegrationAppInstallation_State;
};

export type AppWithVersion = { 
  app?: SlimIntegrationApp;
  installedVersion?: number;
  state?: IntegrationAppInstallation_State;
};

export type InstallationDialogContentType = 
  'selectSubscription' | 
  'showResources' | 
  'confirmUninstallation' | 
  'showApiKeySecrets' | 
  ''
;

export const requiredImageDimensions = { width: 128, height: 128 }